// extracted by mini-css-extract-plugin
export default {"container":"IR-z","topReviewHeading":"JR-z","criticalReview":"KR-z","favorableReview":"LR-z","vsSeparator":"MR-z"};